<template>
  <div class="relations-client--container no-select">

    <div class="relations-client--modifications shadow-card">
      <div class="text-bold">Модификации клиента</div>
      <div class="hint">
        Используется, когда <b>ОДИН НОМЕР -> МНОГО КЛИЕНТОВ</b>.<br>
        Если ваш клиент записывает под своим номером не только себя, то
        можно использовать модификации. Таким образом вы будете хранить для
        себя более точную историю, кто именно записывался. Выберите модификацию
        по умолчанию, если требуется, чтобы она атоматически выбиралась
        при записях данного клиента . Если у вас будут объединенные клиенты, то
        у них будет общая модификация по умолчанию
      </div>
      <div v-if="modificationsList.length > 0" class="mrg-t-20">
        <div class="table--container--without-min-width">
          <div class="table--header center">
            <div class="name">Название</div>
            <div class="default">По умолчанию</div>
            <div class="delete">Удалить</div>
          </div>
          <div class="table--rows">
            <div class="table--row center" v-for="item in modificationsList" :key="item.id">
              <div class="name">{{item.name}}</div>
              <div class="default">
                <toggle-button
                  :mode="'int'"
                  v-model="item.is_default"
                  @input="setAsDefault(item.is_default, item.id)"
                ></toggle-button>
              </div>
              <div class="delete">
                <!-- <div class="btn btn-sm btn-danger">
                  <f-awesome icon="times"></f-awesome>
                </div> -->
                <div @click="showDeleteModificationPopup(item.id)" class="btn-badge btn-danger">
                  <f-awesome icon="times"></f-awesome>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="addModificationShow" class="mrg-t-20">
        <div class="input-block">
          <label for="new-modification">Название модификации</label>
          <input
            type="text"
            v-model="addModificationModel"
            id="new-modification"
          />
        </div>
        <div class="input-block">
          <div @click="cancelAddModification" class="btn-badge btn-danger">Отмена</div>
          <div @click="addModificationSubmit" class="btn-badge btn-success">Сохранить</div>
        </div>
      </div>
      <div v-if="!addModificationShow" @click="addModification" class="btn-badge btn-success mrg-t-15">
        <f-awesome icon="plus"></f-awesome>
        Модификация
      </div>
    </div>

    <div class="relations-client--relations shadow-card mrg-t-20">
      <div class="text-bold">Объединение клиентов</div>
      <div class="hint">
        Используется, когда <b>МНОГО НОМЕРОВ -> ОДИН КЛИЕНТ</b>
        или же <b>МНОГО НОМЕРОВ -> МНОГО КЛИЕНТОВ</b>
        <br>
        Если несколько клиентов записывают кого-то одного.
        Это могут быть разные члены семьи, которые записывают одного ребенка или
        же любимого питомца, а так же и сами члены семьи могут оформить запись на себя.
        При объединении клиентов, у них объединяется
        список модификаций
      </div>
      <div v-if="unionList.length > 0" class="mrg-t-20">
        <div class="table--container--without-min-width">
          <div class="table--header center">
            <div class="name">Клиент</div>
            <div class="delete">Удалить</div>
          </div>
          <div class="table--rows">
            <div class="table--row center" v-for="item in unionList" :key="item.id">
              <div class="name">
                <div>{{ item.surname }} {{ item.name }} {{ item.lastname }}</div>
                <div class="mrg-t-5 text-bold">{{ phoneNumberToMask(item.number) }}</div>
              </div>
              <div class="delete">
                <div @click="showDeleteRelationPopup(item.id)" class="btn-badge btn-danger">
                  <f-awesome icon="times"></f-awesome>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!addRelationShow" @click="addRelation" class="btn-badge btn-success mrg-t-15">
        <f-awesome icon="plus"></f-awesome>
        Объединение
      </div>
      <div v-if="addRelationShow" class="mrg-t-20">
        <div class="mrg-b-20">
          <search-client
            v-model="addRelationModel"
            :reset="resetSearchClient"
            :hideAdd="true"
          ></search-client>
        </div>
        <div class="input-block">
          <div @click="cancelAddRelation" class="btn-badge btn-danger">Отмена</div>
          <div @click="addRelationSubmit" class="btn-badge btn-success">Сохранить</div>
        </div>
      </div>
    </div>


    <popup
      :closeButton="deleteModificationPopup.closeButton"
      :show="deleteModificationPopup.show"
      :actionButton="deleteModificationPopup.actionButton"
      :actionClass="deleteModificationPopup.actionClass"
      @closePopup="closeDeleteModificationPopup"
      @actionPopup="deleteModificationSubmit"
    >
      <div slot="header">Удаление модификации</div>
      <div slot="body">
        Модификация будет удалена без возможности восстановления. Уже
        имеющиеся записи клиента с данной модификацией не пострадают. Продолжить?
      </div>
    </popup>


    <popup
      :closeButton="deleteRelationPopup.closeButton"
      :show="deleteRelationPopup.show"
      :actionButton="deleteRelationPopup.actionButton"
      :actionClass="deleteRelationPopup.actionClass"
      @closePopup="closeDeleteRelationPopup"
      @actionPopup="deleteRelationSubmit"
    >
      <div slot="header">Удаление объединения</div>
      <div slot="body">
        Объединение клиентов будет удалено без возможности восстановления. Продолжить?
      </div>
    </popup>

  </div>
</template>

<script>
import Formatter from "@/components/libraries/Formatter";
const formatter = new Formatter();

import ToggleButton from '../../ui_elements/ToggleButton.vue';
import Popup from '../../Popup.vue';
import SearchClient from './SearchClient.vue';
import clientsRepository from "../../../repositories/clients";

export default {
  name: "RelationsClient",
  components: {
    ToggleButton,
    Popup,
    SearchClient
  },
  data() {
    return {
     modificationsList: [],
     deleteModificationPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedModificationId: 0,

      addModificationShow: false,
      addModificationModel: '',

      unionList: [],
      deleteRelationPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedRelationClientId: 0,
      addRelationShow: false,
      addRelationModel: null,
      resetSearchClient: 0
    };
  },
  props: {
    id: Number // ID клиента для загрузки данных
  },
  watch: {
    id: function(){
      this.getModifications();
      this.getRelations();
    }
  },
  computed: {},
  methods: {
    deleteRelationSubmit(){
      this.$store.dispatch("startPreloader");

      clientsRepository.deleteUnion({
        client_id: this.id,
        deleted_client_id: this.deletedRelationClientId
      }).then(() => {
        this.getRelations();
        this.closeDeleteRelationPopup();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeDeleteRelationPopup(){
      this.deleteRelationPopup.show = false;
    },
    showDeleteRelationPopup(clientId){
      this.deleteRelationPopup.show = true;
      this.deletedRelationClientId = clientId;
    },
    phoneNumberToMask(number){
      return formatter.phoneNumberToMask(number);
    },
    getRelations(){
      clientsRepository.getUnion({client_id: this.id}).then(resp => {
        this.unionList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    addRelation(){
      this.addRelationShow = true;
    },
    cancelAddRelation(){
      this.addRelationShow = false;
      this.addRelationModel = null;
      this.resetSearchClient++;
    },
    addRelationSubmit(){
      if(!this.addRelationModel){
        this.$store.dispatch("addNotification", {
          text: 'Вы не выбрали клиента',
          time: 3,
          color: "danger"
        });
        return false;
      }
      if(this.id === +this.addRelationModel.id){
        this.$store.dispatch("addNotification", {
          text: 'Невозможно объединить клиента с самим собой',
          time: 3,
          color: "danger"
        });
        return false;
      }
      this.$store.dispatch("startPreloader");

      clientsRepository.setUnion({
        client_id: this.id,
        unit_client_id: this.addRelationModel.id
      }).then(() => {
        this.getRelations();
        this.cancelAddRelation();
        this.getModifications();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteModificationSubmit(){
      this.$store.dispatch("startPreloader");

      clientsRepository.deleteModification({
        client_id: this.id,
        modification_id: this.deletedModificationId
      }).then(() => {
        this.getModifications();
        this.closeDeleteModificationPopup();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    showDeleteModificationPopup(modificationId){
      this.deletedModificationId = modificationId;
      this.deleteModificationPopup.show = true;
    },
    closeDeleteModificationPopup(){
      this.deleteModificationPopup.show = false;
    },
    addModification(){
      this.addModificationShow = true;
    },
    cancelAddModification(){
      this.addModificationShow = false;
      this.addModificationModel = '';
    },
    addModificationSubmit(){
      this.$store.dispatch("startPreloader");

      clientsRepository.addModification({
        name: this.addModificationModel,
        client_id: this.id
      }).then(() => {
        this.addModificationShow = false;
        this.addModificationModel = '';
        this.getModifications();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 3,
          color: "success"
        });

        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getModifications(){
      clientsRepository.getModifications({client_id: this.id}).then(resp => {
        this.modificationsList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    setAsDefault(value, modificationId){
      this.$store.dispatch("startPreloader");

      clientsRepository.setModificationDefault({
        client_id: this.id,
        modification_id: modificationId,
        value: value === 1
      }).then(() => {
        this.getModifications();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {
    this.getModifications();
    this.getRelations();
  }
};
</script>

<style scoped lang="less">

</style>
